import {Box, Typography} from '@mui/material';
import Lottie from 'lottie-react';
import {useTranslation} from 'react-i18next';

import {PaymentLinkV2Campaign} from '@/app/main/paymentLink/models/constants/paymentLink.constants';
import {AppButton, AppButtonVariant} from '@/app/shared-components';
import {CheckSmall} from '@/app/shared-components/CheckSmall/CheckSmall';

import {SPLITS_LOTTIES} from '../constants';

interface SplitsPromoCardProps {
  inApp: boolean;
  handleSplitWithMo: () => void;
  handleOpenAccount: () => void;
  buttonVariant?: AppButtonVariant;
}

const ImageSplitBillsCta = ({inApp}: {inApp: boolean}) => (
  <Box className="splits-promo-lottie-container">
    {inApp ? (
      <Lottie
        className="mdk-lottie"
        style={{
          maxHeight: '81px',
        }}
        animationData={SPLITS_LOTTIES.MO_BILL}
        loop
        autoplay
      />
    ) : (
      <Lottie
        className="mdk-lottie"
        animationData={SPLITS_LOTTIES.MO_CARDS}
        loop
        autoplay
      />
    )}
  </Box>
);

const SplitsBulletsItems = ({items}: {items: string[]}) => {
  return (
    <Box className="splits-bullets-items">
      {items.map((item, index) => (
        <Box
          className="splits-bullets-item"
          key={index}>
          <CheckSmall />
          <Typography className="splits-bullets-item-text">{item}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export const SplitsPromoCard = ({
  inApp,
  handleSplitWithMo,
  handleOpenAccount,
  buttonVariant = AppButtonVariant.onQuinary,
}: SplitsPromoCardProps) => {
  const {t} = useTranslation();

  if (inApp) {
    return (
      <Box className="splits-confirmation-card splits-confirmation-promo-in-app">
        <Typography
          className="splits-confirmation-card-title"
          component="h2">
          {t('split_bills_page.confirmation.promo_title_in_app')}
        </Typography>
        <SplitsBulletsItems
          items={[
            t('split_bills_page.confirmation.promo_bullet_1'),
            t('split_bills_page.confirmation.promo_bullet_2'),
            t('split_bills_page.confirmation.promo_bullet_3'),
          ]}
        />
        <ImageSplitBillsCta inApp={inApp} />
        <AppButton
          id="splits-confirmation-split-with-mo"
          onClick={handleSplitWithMo}
          label={t('split_bills_page.confirmation.promo_button_in_app')}
          variant={buttonVariant}
        />
      </Box>
    );
  }

  return (
    <>
      <Box className="splits-confirmation-card splits-confirmation-promo-no-app">
        <Typography
          className="splits-confirmation-card-title"
          component="h2">
          {t('split_bills_page.confirmation.family_banking_title')}
        </Typography>
        <Typography className="splits-confirmation-offer">
          {t('split_bills_page.confirmation.family_banking_offer', {
            amount: PaymentLinkV2Campaign.AMOUNT,
          })}
        </Typography>
        <SplitsBulletsItems
          items={[
            t('split_bills_page.confirmation.family_bullet_1'),
            t('split_bills_page.confirmation.family_bullet_2'),
            t('split_bills_page.confirmation.family_bullet_3'),
          ]}
        />
        <ImageSplitBillsCta inApp={inApp} />
        <AppButton
          id="splits-confirmation-open-account"
          onClick={handleOpenAccount}
          label={t('split_bills_page.confirmation.open_account_button')}
          variant={buttonVariant || AppButtonVariant.onSecondary}
        />
      </Box>
      <Box className="splits-confirmation-disclaimer">
        <Typography className="splits-confirmation-disclaimer-text">
          {t('split_bills_page.confirmation.disclaimer_deposit')}
        </Typography>
        <Typography
          className="splits-confirmation-disclaimer-text"
          dangerouslySetInnerHTML={{
            __html: t('split_bills_page.confirmation.disclaimer_referral'),
          }}
        />
        <Typography
          className="splits-confirmation-disclaimer-text"
          dangerouslySetInnerHTML={{
            __html: t('split_bills_page.confirmation.disclaimer_cardholder'),
          }}
        />
      </Box>
    </>
  );
};
